import {useState} from "react";

export default function SkodaConsentDataInfo() {
    const [openInfo, setOpenInfo] = useState(false);
    return (
        <div className="form-info-container">
            <div className="form-info">
                <p onClick={() => setOpenInfo(!openInfo)} className="more-info more-info-link js-btn-more-info"
                   data-status="0">rozwiń</p>
                {openInfo &&
                    <div className="more-info js-more-info">
                        <p>
                            relacji biznesowej z VGP lub z Autoryzowanym Dealerem lub Autoryzowanym Partnerem Serwisowym, w celu marketingu dot. produktów i usług marki Skoda oraz innych powiązanych z marką Skoda akcesoriów, produktów i usług motoryzacyjnych, w tym także w celu profilowania na potrzeby marketingu oraz realizacji działań posprzedażowych polegających na prowadzeniu i analizie badań: satysfakcji klienta lub zainteresowania marką, produktami i usługami marki Skoda.
                        </p>
                        <p style={{textDecoration: "underline", cursor: "pointer"}} onClick={() => setOpenInfo(false)} className="js-btn-more-info">Zwiń</p>
                    </div>
                }
            </div>
        </div>
    );
}
